import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import CustomModal from "../../../modals/Modal"
import { Link, useNavigate } from "react-router-dom"
import Spinners from "components/Common/Spinner"
import {
  formatAmount,
  formatTenure,
  getFundRequirementDate,
} from "helpers/common"
import moment from "moment"
import toast from "react-hot-toast"
import NoDataFound from "components/Common/NoDataFound"
import LoaderComponent from "components/loader"
import Breadcrumb from "components/Common/Breadcrumb"
import ProgressBar from "@ramonak/react-progress-bar"
import SignAgreementModal from "pages/InvestorPages/signAgreementModal"
import {
  useLazyGetFundRequestsWpQuery,
  useShowInterestWpMutation,
} from "store/api/wealthpartnerapi/wpicds.api"
import CounterFundRequestModal from "./counterFundRequestModal"
import ShowInterestWp from "./ShowInterestWp"

const defaultFilters = {
  search: "",
  page: 1,
  created_by: "ADMIN",
  pageSize: 20,
  timestamp: "",
}

const FundRequestsWp = () => {
  document.title = "Fund Requests - Prachay"
  let navigate = useNavigate()
  const [getResults, { isFetching }] = useLazyGetFundRequestsWpQuery()
  const [showInterest, { isLoading }] = useShowInterestWpMutation()
  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([])
  const [open, setOpen] = useState(false)
  const [cancelRequestOpen, setCancelRequestOpen] = useState(false)
  const [selectedData, setSelectedData] = useState()
  const [isToast, setIsToast] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const getList = async () => {
    try {
      const { data } = await getResults(filters).unwrap()
      setData(data)
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [filters])

  // useEffect(() => {
  //   // Show modal on page load
  //   setIsModalOpen(true)
  // }, [])

  const onSuccess = () => {
    setOpen(false)
    setFilters((prev) => ({ ...prev, page: 1, timestamp: moment().unix() }))
    navigate("/investment-management/fund-requests")
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title={"Fund Requests"} />
          <Card>
            <CardBody>
              {isFetching && <LoaderComponent />}
              {!isFetching && data.length > 0 && (
                <>
                  <Row className="my-4 row-gap">
                    {data.map((item, index) => (
                      <Col key={`data_${index}`} xl={4}>
                        <div className="active-bonds-card-wrapper">
                          <div className="d-flex align-items-start justify-content-between">
                            <div className="card-title card-title2">
                              <h4>{item.unique_code}</h4>
                              <p>Admin</p>
                            </div>
                            <div className="bond-status">
                              <p className={item?.status.toLowerCase()}>
                                <span></span>{" "}
                                {item?.status.charAt(0).toUpperCase() +
                                  item?.status.slice(1).toLowerCase()}
                              </p>
                            </div>
                          </div>

                          <div className="card-desc">
                            <div className="card-desc-inner">
                              <h5>Amount</h5>
                              <p>₹ {formatAmount(item.amount)}</p>
                            </div>
                            <div className="card-desc-inner">
                              <h5>Interest Rate</h5>
                              <p>{item.interest_rate}% p.a.</p>
                            </div>
                            <div className="card-desc-inner">
                              <h5>Fund Requirement</h5>
                              <p>
                                {getFundRequirementDate(
                                  item.fund_requirement_date
                                )}
                              </p>
                            </div>
                            <div className="card-desc-inner">
                              <h5>Maturity date</h5>
                              <p>
                                {moment(item.repayment_date).format(
                                  "DD MMM YYYY"
                                )}
                              </p>
                            </div>
                          </div>
                          <hr />
                          <div>
                            <ProgressBar
                              borderRadius="8px"
                              height="8px"
                              baseBgColor="#9b9b9b33"
                              bgColor="#F0A735"
                              completed={
                                item.total_invested_amount > 0
                                  ? Math.max(
                                      (item.total_invested_amount /
                                        item.amount) *
                                        100,
                                      0.01
                                    )
                                  : 0
                              }
                              isLabelVisible={false}
                            />
                            <div className="amount-wrapper">
                              <div className="right-box">
                                <p>
                                  Req. Amount{" "}
                                  <span>
                                    ₹{" "}
                                    {formatAmount(
                                      item.amount - item.total_invested_amount
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                          {item.status === "OPEN" && (
                            <>
                              <hr />
                              <Link
                                to={"#"}
                                onClick={() => {
                                  setSelectedData(item)
                                  setIsToast(true)
                                }}
                              >
                                {item.isLoading ? (
                                  <Spinners />
                                ) : (
                                  "Show Interest"
                                )}
                              </Link>
                              <Link
                                className="counteroffer"
                                to={"#"}
                                onClick={() => {
                                  setSelectedData(item)
                                  setOpen(true)
                                }}
                              >
                                Counter Offer
                              </Link>
                            </>
                          )}
                        </div>
                      </Col>
                    ))}
                  </Row>
                </>
              )}
              {!isFetching && data.length <= 0 && (
                <NoDataFound description="There is currently no fund request to display." />
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
      {open && selectedData && (
        <CounterFundRequestModal
          open={open}
          setOpen={setOpen}
          data={selectedData}
          setCancelRequestOpen={setCancelRequestOpen}
          onSuccess={onSuccess}
        />
      )}
      {selectedData && isToast && (
        <ShowInterestWp
          open={isToast}
          data={{ id: selectedData.id }}
          setOpen={setIsToast}
          isLoading={isLoading}
          onClose={() => {
            setIsToast(false)
          }}
          showInterest={showInterest}
          onSuccess={onSuccess}
        />
      )}

      <SignAgreementModal
        open={cancelRequestOpen}
        setOpen={setCancelRequestOpen}
        showAlert={true}
        assignedInvestors={true}
      />
    </React.Fragment>
  )
}

export default FundRequestsWp
